module.exports = __webpack_public_path__ + "static/media/magnolia.0d350545.jpg";